module.exports = "https://cdn-challenge.mathletics.com/app/285/assets/fonts/f8a7f19f45060f7a177314855b8c7aa3.woff2";